import {
    userInfo,
    login,
    loginForm,
    signUpForm,
    confirmationForm,
    addDomainForm,
    addDomainResourceForm,
    modalPopup,
    siteData,
    accountData,
    paymentMethod
} from './reducers'
import {createStore as createReduxStore, applyMiddleware, combineReducers} from 'redux'
import loggerMiddleware from 'redux-logger'
import thunkMiddleware from 'redux-thunk'

export const appReducer = combineReducers({
    userInfo,
    login,
    loginForm,
    signUpForm,
    confirmationForm,
    addDomainForm,
    addDomainResourceForm,
    modalPopup,
    siteData,
    accountData,
    paymentMethod
});

export const createStore = () => {

	return createReduxStore(
		appReducer,
		applyMiddleware(thunkMiddleware, loggerMiddleware));
}


// WEBPACK FOOTER //
// ./src/redux/utils.js